/*
 * @Author: 朱海良 421973703@qq.com
 * @Date: 2023-10-31 10:50:33
 * @LastEditors: 朱海良 421973703@qq.com
 * @LastEditTime: 2023-10-31 10:58:03
 * @FilePath: \zhw\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Button, Message, Input, Select, Table, TableColumn, Form, FormItem, Option, MessageBox, Loading } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css/normalize.css";
import "@/assets/index.less";

Vue.use(TableColumn)
Vue.use(Table)
Vue.use(Select)
Vue.use(Input)
Vue.use(Button)
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Option);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
